import {
  extractDisplayPrice,
  extractTravellerTypePrice,
} from '@travel-planner/shared/pricing';

const toPositive = (value: unknown): number | null => {
  if (typeof value === 'number' && Number.isFinite(value) && value > 0) {
    return value;
  }
  if (typeof value === 'string' && value.trim()) {
    const parsed = Number(value);
    if (Number.isFinite(parsed) && parsed > 0) return parsed;
  }
  return null;
};

const firstPositiveInList = (value: unknown): number | null => {
  if (!Array.isArray(value)) return null;
  for (const entry of value) {
    const walked = extractDisplayPrice(entry);
    if (walked != null && walked > 0) return walked;
    if (entry && typeof entry === 'object' && 'price' in entry) {
      const nested = toPositive((entry as { price: unknown }).price);
      if (nested != null) return nested;
    }
  }
  return null;
};

// List cells hit `{ price: 0, rooms: [{ price }] }` a lot — extractDisplayPrice
// returns the top-level 0 and never walks rooms. Prefer a real room/pax amount.
export const advisorClientPrice = (
  price: unknown,
  adultTravellerIds?: ReadonlySet<string>
): number | null => {
  const display = extractDisplayPrice(price, adultTravellerIds);
  if (display != null && display > 0) return display;
  if (!price || typeof price !== 'object') return display;
  const obj = price as Record<string, unknown>;
  const nested =
    firstPositiveInList(obj.rooms ?? obj.room) ??
    firstPositiveInList(obj.travellers);
  if (nested != null) return nested;
  return display != null && display > 0 ? display : null;
};

/**
 * A per-person product's Child rate (the org's child traveller types). Null
 * when it lists none or leaves it at 0 — children then pay the Adult rate.
 */
export const advisorChildPrice = (
  price: unknown,
  childTravellerIds?: ReadonlySet<string>
): number | null => {
  const child = extractTravellerTypePrice(price, childTravellerIds);
  return child != null && child > 0 ? child : null;
};
